import React from 'react'
import classes from '../kgpmap.module.css'

const GuideMap = () => {
    return ( 
        <div>
            <img src="https://raw.githubusercontent.com/TSG-Website/media/master/Maps/map%201.png" className={classes.guidemap}/>
        </div>
     );
}
 
export default GuideMap;